const retailLocations = [
  {
    name: "Dorset",
    id: "dorset",
    slug: "dorset",
    area: "haliburton",
    lakes: [
      { name: "Lake of Bays", id: "lakeofbays", area: "muskoka" },
      { name: "Kawagama Lake", id: "kawagamalake", area: "haliburton" },
      { name: "Oxtongue Lake", id: "oxtonguelake", area: "haliburton" },
      { name: "Raven Lake", id: "ravenlake", area: "haliburton" },
      { name: "Canoe Lake", id: "canoelake", area: "algonquinpark" },
      { name: "Lake of Two Rivers", id: "lakeoftworivers", area: "algonquinpark" }
    ]
  },
  {
    name: "Haliburton",
    id: "haliburton",
    slug: "haliburton",
    area: "haliburton",
    lakes: [
      { name: "Kennisis Lake", id:"kennisislake", area: "haliburton" },
      { name: "Kashagawigamog Lake", id:"kashagawigamoglake", area: "haliburton" },
      { name: "Haliburton Lake", id:"haliburtonlake", area: "haliburton" },
      { name: "Redstone Lake", id:"redstonelake", area: "haliburton" },
      { name: "Drag Lake", id:"draglake", area: "haliburton" },
      { name: "Head Lake", id:"headlake", area: "haliburton" }
    ]
  },
  {
    name: "Carnarvon",
    id: "carnarvon",
    slug: "carnarvon",
    lakes: [
      { name: "Boshkung Lake", id: "boshkunglake", area: "haliburton" },
      { name: "Twelve Mile Lake", id: "twelvemilelake",area: "haliburton" },
      { name: "Maple Lake", id:"maplelake", area: "haliburton" },
      { name: "Halls Lake", id:"hallslake", area: "haliburton" },
      { name: "Horseshoe Lake", id:"horseshoelake", area: "haliburton" },
      { name: "Kushog Lake", id:"kushoglake", area: "haliburton" }
    ]
  },
  {
    name: "West Guilford",
    id: "westguilford",
    slug: "westguilford",
    lakes: [
      { name: "Kennisis Lake", id: "kennisislake", area: "haliburton" },
      { name: "Redstone Lake", id: "redstonelake", area: "haliburton" },
      { name: "Eagle Lake", id:"eaglelake", area: "haliburton" },
      { name: "Maple Lake", id:"maplelake", area: "haliburton" },
      { name: "Boshkung Lake", id:"boshkunglake", area: "haliburton" },
      { name: "Head Lake", id:"headlake", area: "haliburton" }
    ]
  },
  {
    name: "Dwight",
    id: "dwight",
    slug: "dwight",
    lakes: [
      { name: "Lake of Bays", id: "lakeofbays", area: "muskoka" },
      { name: "Lake of Two Rivers", id: "lakeoftworivers", area: "algonquinpark" },
      { name: "Kawagama Lake", id: "kawagamalake", area: "haliburton" },
      { name: "Oxtongue Lake", id: "oxtonguelake", area: "haliburton" },
      { name: "Peninsula Lake", id: "peninsulalake", area: "muskoka" },
      { name: "Lake Vernon", id: "lakevernon", area: "muskoka" }
    ]
  },
  {
    name: "Huntsville",
    id: "huntsville",
    slug: "huntsville",
    lakes: [
      { name: "Lake Vernon", id: "lakevernon", area: "muskoka" },
      { name: "Lake of Two Rivers", id: "lakeoftworivers", area: "algonquinpark" },
      { name: "Lake of Bays", id:"lakeofbays", area: "muskoka" },
      { name: "Skeleton Lake", id:"skeletonlake", area: "muskoka" },
      { name: "Peninsula Lake", id:"peninsulalake", area: "muskoka" },
      { name: "Canoe Lake", id:"canoelake", area: "algonquinpark" }
    ]
  },
  {
    name: "Bracebridge",
    id: "bracebridge",
    slug: "bracebridge",
    lakes: [
      { name: "Lake Rosseau", id: "lakerosseau", area: "muskoka" },
      { name: "Lake Joseph", id: "lakejoseph", area: "muskoka" },
      { name: "Lake Vernon", id:"lakevernon", area: "muskoka" },
      { name: "Lake of Bays", id:"skeletonlake", area: "muskoka" },
      { name: "Skeleton Lake", id:"skeletonlake", area: "muskoka" },
      { name: "Fairy Lake", id:"fairylake", area: "muskoka" }
    ]
  }
];
